/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.show-search-link';
    var searchInputMobile = '.main-search__input';
    var searchCloseButtonMobile = '.main-search__close';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.show-search-link';
    var searchInputDesktop = '.main-search__input';
    var searchCloseButtonDesktop = '.main-search__close';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
      // Overide this method for customization
      jQ(searchCloseButtonDesktop).trigger('click');
  }

  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
    switch (tempType) {
      case InstantSearchResultItemProduct.tempType.IMAGE:
        return `
  					<div class="{{class.searchSuggestion}}-left">
  						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
  					</div>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.SKU:
        return `
  					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.VENDOR:
        return `
  					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.PRICE:
        return `
  					<p class="{{class.searchSuggestion}}-product-price">
  						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
  					</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.PRICE_SALE:
        return `
  					<p class="{{class.searchSuggestion}}-product-price">
              <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
  						<s>{{compareAtPrice}}</s>
  						
  					</p>
  				`.trim();
      default:
        return `
  					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
  						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
  							{{itemProductImage}}
  							<div class="{{class.searchSuggestion}}-right">
  								{{itemProductVendor}}
  								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
  								{{itemProductSku}}
  								{{itemProductPrice}}
  							</div>
  						</a>
  					</li>
  				`.trim();
    }
  }

  // Boost Start #176277
  InstantSearchResultBlockEmpty.prototype.compileTemplate = function() {
		var searchTerm = Utils.stripHtml(Globals.currentTerm);
		var noResultLabel = Labels.error.noSuggestionResult;
    console.log('123',this.getTemplate());
		noResultLabel = noResultLabel.replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>');
    console.log(noResultLabel);
		return this.getTemplate()
			.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
			.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
			.replace(/{{searchTerm}}/g, searchTerm)
			.replace(/{{noResultLabel}}/g, noResultLabel);
	}

  InstantSearchResultBlockEmpty.prototype.getTemplate = function() {
		return `
			<div class="{{class.searchSuggestion}}-no-result" data-group="empty" data-label="No Results: {{searchTerm}}" data-value="{{searchTerm}}" aria-label="No Results">
				<p>{{noResultLabel}}</p>
                <div>Please check your spelling or try a new search</div>
			</div>
		`.trim();
	}
  // Boost End #176277
  /* Start boost 175267 */
  InstantSearchResultItemPopular.prototype.beforeRender = function () {
    if (this.data) {
    var searchTerm = this.data;
    var selectionUrl = '';
      switch(searchTerm) {
        // Start cases
        case 'new arrivals': // please setup this search term in our app admin
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/all-new-in'; // new url
        break;
        //
        case 'women':
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/womens-spotlight-all-womens';
        break;
        //
        case 'men':
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/mens-sandals';
        break;
        //
        case 'kids':
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/womens-spotlight-all-womens';
        break;
        //
        case 'technology':
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/womens-spotlight-all-womens';
        break;
        //
        case 'outlet':
          selectionUrl = 'https://fitflopstore-id.myshopify.com/collections/womens-spotlight-all-womens';
        break;
        // End cases  
        default:
          break;
      }
    this.searchLink = selectionUrl;
    }
  }
/* End boost 175267 */


  Utils.buildProductItemUrl = function(data, hasCollection) {
      // Get url information
      var params = Utils.getWindowLocation().search.substring(1);
      var pathname = window.location.pathname;
      var elements = pathname.split('/');
    
      // Check if has locale
      var localeURLPart = "";
      var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
      if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
      } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
      }
    
      // Get product handle
      var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
      var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
      if (hasCollection) {
        // Homepage or Search page
        if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
          var preHandle = localeURLPart + '/collections/all/products/';
          return preHandle + handle;
    
          // Tag Page
        } else if (Utils.isTagPage()) {
          var preHandle = localeURLPart + '/collections/';
          var collectionHandleIndex = elements.indexOf("collections") + 1
          if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          return '/collections/all/products/' + handle;
        } else {
          // Google cache URL
          // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
          if (params.indexOf('cache:') > -1) {
            var collectionHandle = 'all';
            var temp = params.split('&')[0].split('?')[0].split('collections/');
            if (temp.length > 1) {
              if (temp[1].indexOf('/') > -1) {
                collectionHandle = temp[1].split('/')[0];
              } else {
                collectionHandle = temp[1];
              }
            }
            collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
            return '/collections/' + collectionHandle + '/products/' + handle;
          }
          var collectionHandleIndex = elements.indexOf("collections") + 1;
          var preHandle = localeURLPart + '/collections/';
          
          if (typeof elements[2] !== 'undefined') {
            // Build for collection pages
            if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
              return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
            }
            //Build for other pages, use collection/all
            return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
          } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
            return '/products/' + handle;
          }
          return window.location.pathname + '/products/' + handle;
        }
      }
      return localeURLPart + '/products/' + handle;
    };

    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
        console.log('searchTerm', searchTerm);
        Globals.instantSearchQueryParams = {'suggest_types': ['products', 'redirect', 'suggestions']};
    }
  
})();